// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_g4-0";
export var optionCard = "_g4-1";